import { useState, useEffect } from 'react'
import RescheduleCalendar from './RescheduleCalendar'
import { MeetingListItem } from '../types/meeting'
import { Professional } from '../lib/professionalService'
import { getProfessionalById } from '../lib/professionalService'

interface RescheduleMeetingModalProps {
  open: boolean
  onClose: () => void
  meeting: MeetingListItem
  onRescheduleRequested: () => void
  onError?: (message: string) => void
}

export default function RescheduleMeetingModal({
  open,
  onClose,
  meeting,
  onRescheduleRequested,
  onError
}: RescheduleMeetingModalProps) {
  const [professional, setProfessional] = useState<Professional | null>(null)

  // Load professional data
  useEffect(() => {
    const loadProfessional = async () => {
      try {
        const prof = await getProfessionalById(meeting.professionalId)
        setProfessional(prof)
      } catch (err) {
        console.error('Error loading professional:', err)
      }
    }

    if (open) {
      loadProfessional()
    }
  }, [meeting.professionalId, open])

  return (
    <RescheduleCalendar
      open={open}
      onClose={onClose}
      professional={professional}
      meetingId={meeting.id}
      fixedDuration={meeting.duration}
      onRescheduleRequested={onRescheduleRequested}
      onError={onError}
    />
  )
}
